import { FC } from 'react';

interface IconGiftProps {
    className?: string;
    fill?: boolean;
    duotone?: boolean;
}

const IconGift: FC<IconGiftProps> = ({ className, fill = false, duotone = true }) => {
    return (
        <>
            {!fill ? (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
                    <path
                        opacity={duotone ? '0.5' : '1'}
                        d="M20 12V17C20 18.8856 20 19.8284 19.4142 20.4142C18.8284 21 17.8856 21 16 21H8C6.11438 21 5.17157 21 4.58579 20.4142C4 19.8284 4 18.8856 4 17V12"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />
                    <path d="M2 9C2 7.11438 2 6.17157 2.58579 5.58579C3.17157 5 4.11438 5 6 5H18C19.8856 5 20.8284 5 21.4142 5.58579C22 6.17157 22 7.11438 22 9C22 10.8856 22 11.8284 21.4142 12.4142C20.8284 13 19.8856 13 18 13H6C4.11438 13 3.17157 13 2.58579 12.4142C2 11.8284 2 10.8856 2 9Z" stroke="currentColor" strokeWidth="1.5" />
                    <path opacity={duotone ? '0.5' : '1'} d="M12 21V5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                    <path d="M12 5C12 5 11 2 8.5 2C6 2 6 5 8.5 5H12ZM12 5C12 5 13 2 15.5 2C18 2 18 5 15.5 5H12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            ) : (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M18 5H6C4.11438 5 3.17157 5 2.58579 5.58579C2 6.17157 2 7.11438 2 9C2 10.8856 2 11.8284 2.58579 12.4142C3.17157 13 4.11438 13 6 13H11V21H8C6.11438 21 5.17157 21 4.58579 20.4142C4 19.8284 4 18.8856 4 17V12.7291C4.30138 12.8719 4.67562 12.9467 5.15286 12.9774C5.41914 12.9945 5.71987 13 6.11111 13H11H13H17.8889C18.2801 13 18.5809 12.9945 18.8471 12.9774C19.3244 12.9467 19.6986 12.8719 20 12.7291V17C20 18.8856 20 19.8284 19.4142 20.4142C18.8284 21 17.8856 21 16 21H13V13H18C19.8856 13 20.8284 13 21.4142 12.4142C22 11.8284 22 10.8856 22 9C22 7.11438 22 6.17157 21.4142 5.58579C20.8284 5 19.8856 5 18 5ZM12 5H8.5C6 5 6 2 8.5 2C11 2 12 5 12 5ZM12 5H15.5C18 5 18 2 15.5 2C13 2 12 5 12 5Z"
                        fill="currentColor"
                    />
                </svg>
            )}
        </>
    );
};

export default IconGift;
